import { Component, Input, SimpleChanges, SimpleChange, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Question } from 'src/app/model/question';
import { RadioButtonGroupConfig } from 'src/app/model/radio-button/radio-button-group';
import { RadioButton } from 'src/app/model/radio-button/radio-button';
import { AnalyticsService, AnnuityReadyService, CurrencyFunctionalityService, UtilService } from 'src/app/shared';
import { Location } from '@angular/common';
@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    imports: []
})

export class NotificationComponent implements OnChanges {
  @Input() title;
  @Input() notificationText;
  @Input() btnFlag;
  @Input() btnText;
  @Input() msgCode;
  @Input() difference;
  @Input() isLngIsBest;
  @Input() displayWOMPanel;
  @Input() padsRefNumber;
  @Input() comparatorError;
  @Input() consentMessageError;
  private compDifference;
  private processedString;
  private insertIndex;
  public showError: boolean = false;
  public contentData;
  constructor(private annuityReadyService: AnnuityReadyService,
    private location: Location, private activatedRoute: ActivatedRoute, private analyticsService: AnalyticsService,
    private router: Router, private utilService: UtilService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.productQuoteComparison;
  }

  ngOnChanges() {
    this.compDifference = this.difference;
    this.processedString = this.notificationText;
    this.handleProcessedText();
  }


  agreeToAnnuity() {
    this.analyticsService.eventTrack({
      type: 'ButtonClick',
      name: this.btnText,
      pageID: this.utilService.getScreenNameFromURL(this.router.url)
    });
    this.showError = false;
    if (this.padsRefNumber && this.padsRefNumber !== '') {
      this.annuityReadyService.annuityReadyRequest(this.padsRefNumber).subscribe(res => {
        if (res && res.womURL) {
          this.location.replaceState('/');
          window.open(res.womURL, '_blank');
        } else {
          this.showError = true;
        }
      },
        errr => {
          this.showError = true;
        });
    }
  }

  handleProcessedText() {
    this.insertIndex = this.processedString.indexOf('£') + 1;
    if (this.msgCode === 2 || this.msgCode === 3) {
      if (this.compDifference && this.compDifference > 0) {
        this.compDifference = CurrencyFunctionalityService.convertNumberToCurrency(this.compDifference);
      }
      this.insert(this.processedString, this.compDifference, this.insertIndex);
    } else {
      this.processedString = this.notificationText;
    }
  }

  insert(processedString, compDifference, insertIndex) {
    if (typeof (insertIndex) === 'undefined') {
      insertIndex = 0;
    }
    if (typeof (compDifference) === 'undefined') {
      compDifference = '';
    }
    this.processedString = processedString.slice(0, insertIndex) + compDifference + processedString.slice(insertIndex);
    return this.processedString;
  }

}
